import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell, googleLogin } from "@/pages/AuthShell";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back!");
      const from = location.state?.from;
      navigate(from || (user.role === "admin" ? "/admin" : user.seller_type ? "/dashboard" : "/onboard"), { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Log in to Vorra" subtitle="Access your listings, messages and plan.">
      <Button type="button" onClick={googleLogin} variant="outline" className="w-full h-11 mb-4" data-testid="google-login-btn">
        <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-4 h-4 mr-2" />
        Continue with Google
      </Button>
      <div className="relative my-4 text-center"><span className="bg-background px-2 text-xs text-muted-foreground relative z-10">or with email</span><div className="absolute inset-0 top-1/2 border-t border-border" /></div>
      <form onSubmit={submit} className="space-y-4">
        <div><Label>Email</Label><Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" /></div>
        <div><div className="flex justify-between items-center"><Label>Password</Label><Link to="/forgot-password" className="text-xs text-accent font-medium" data-testid="login-forgot-link">Forgot password?</Link></div><Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" /></div>
        <Button type="submit" disabled={loading} className="w-full h-11 bg-primary text-white" data-testid="login-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Log in"}
        </Button>
      </form>
      <p className="text-sm text-muted-foreground mt-6 text-center">No account? <Link to="/register" className="text-accent font-medium">Sign up</Link></p>
    </AuthShell>
  );
}
